import { Title } from "@mantine/core";
import React from "react";

export default function Resources() {
  return <Title ta="center">Resources Page</Title>;
}
